import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter)
const router = new VueRouter({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        // 全心权益首页
        {
            path: '/main',
            name: 'main',
            component: () => import("../view/qxqyindex/index.vue"),
            children: [
                {
                    path: '/index',
                    name:"index",
                    component :() => import("../view/qxqyindex/qxqy.vue")
                },
                {
                    path: '/content',
                    name:"content",
                    component :() => import("../view/qxqyindex/content.vue")
                },
                {
                    path: '/about',
                    name:"about",
                    component :() => import("../view/qxqyindex/aboutous.vue")
                },
            ]
        },
        // 大通预约车辆
        {
            path: '/qxqyordercar',
            name: 'qxqyordercar',
            component: () => import("../view/qxqyordercar/qxqyordercar.vue")
        },
        // 测试
        {
            path: '/acc',
            component: () => import("../view/index.vue")
        },
    ],

})
export default router
